import React, { useState, useEffect } from 'react';

const NotesEditor = () => {
    const [notes, setNotes] = useState('');
    const [isExpanded, setIsExpanded] = useState(false);

    // Load notes from localStorage on component mount
    useEffect(() => {
        const savedNotes = localStorage.getItem('labNotes');
        if (savedNotes) {
            setNotes(savedNotes);
        }
    }, []);

    // Save notes to localStorage whenever notes change
    useEffect(() => {
        localStorage.setItem('labNotes', notes);
    }, [notes]);

    const handleNotesChange = (e) => {
        setNotes(e.target.value);
    };

    const clearNotes = () => {
        setNotes('');
        localStorage.removeItem('labNotes');
    };

    const toggleExpanded = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <h4 style={styles.title}>📝 Notes</h4>
                <div style={styles.buttonGroup}>
                    <button
                        onClick={toggleExpanded}
                        style={styles.expandButton}
                        title={isExpanded ? "Collapse" : "Expand"}
                    >
                        {isExpanded ? '📉' : '📈'}
                    </button>
                    <button
                        onClick={clearNotes}
                        style={styles.clearButton}
                        title="Clear notes"
                    >
                        🗑️
                    </button>
                </div>
            </div>

            <textarea
                value={notes}
                onChange={handleNotesChange}
                placeholder="Tapez vos notes ici..."
                style={{
                    ...styles.textarea,
                    height: isExpanded ? '300px' : '150px'
                }}
            />

            <div style={styles.footer}>
                <small style={styles.footerText}>
                    Vos notes sont sauvegardées automatiquement
                </small>
            </div>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: '#2d3748',
        border: '1px solid #4a5568',
        borderRadius: '8px',
        padding: '16px',
        margin: '16px 0',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '12px',
    },
    title: {
        color: '#e2e8f0',
        margin: 0,
        fontSize: '16px',
        fontWeight: '600',
    },
    buttonGroup: {
        display: 'flex',
        gap: '8px',
    },
    expandButton: {
        backgroundColor: '#4299e1',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '4px 8px',
        cursor: 'pointer',
        fontSize: '14px',
        transition: 'background-color 0.2s',
    },
    clearButton: {
        backgroundColor: '#f56565',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        padding: '4px 8px',
        cursor: 'pointer',
        fontSize: '14px',
        transition: 'background-color 0.2s',
    },
    textarea: {
        width: '100%',
        minHeight: '150px',
        backgroundColor: '#1a202c',
        color: '#e2e8f0',
        border: '1px solid #4a5568',
        borderRadius: '6px',
        padding: '12px',
        fontSize: '14px',
        fontFamily: 'monospace',
        resize: 'vertical',
        transition: 'height 0.3s ease',
        outline: 'none',
        boxSizing: 'border-box',
    },
    footer: {
        marginTop: '8px',
        textAlign: 'center',
    },
    footerText: {
        color: '#a0aec0',
        fontStyle: 'italic',
    },
};

export default NotesEditor;
